import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../Components/TimeModal/TimeModalContext';
import { formatDateTime, isWithinLastHalfHour } from '../Utils/GlobalUtils';

import LoadingLines from './LoadingLines';
import WarningPanel from './WarningPanel';
import ButtonWithConfirmation from './ButtonWithConfirmation';

import styles from '../styles/MiniTables.module.css';

import ViewFileById from './ViewFileById';

const FilesMiniTable = ({ file_ids, isShowNullTable, isAdmin, deleteBan, handleDelete, reload }) => {
  const { openTimeModal } = useTimeModal();

  const [files, setFiles] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [warning, setWarning] = React.useState('');

  React.useEffect(() => {
    const token = localStorage.getItem('token');

    if (!file_ids || file_ids.length === 0) {
      if (isShowNullTable) setWarning('Файлы не прикреплены');
      setFiles([]);
      setLoading(false);
      return;
    }
    
    axios.get(`/api/get-files-table`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        file_ids: file_ids.join(','),
      }
    })
    .then((response) => {
      if (response.data.length === 0) {
        if (isShowNullTable) {
          setWarning('Файлы не прикреплены');
        } else {
          setWarning('');
        }
        setFiles([]);
      } else {
        setWarning(``);
        setFiles(response.data);
      }
    })
    .catch((error) => {
      setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
      setFiles([]);
    })
    .finally(() => {
      setLoading(false);
    })
  }, [reload, file_ids.join(',')]);

  return (
    <>
      {loading ? <LoadingLines />
      : warning ? <WarningPanel text={warning} />
      : files.length > 0 && 
      <div className={styles.table}>
        {files.map((file) => (
            <div 
              className={styles.line} 
              key={file.id} 
              style={{ gridTemplateColumns: '55fr 32fr 5fr 18fr' }}
            >
              <div>{file.name}</div>
              <div className='description'>{formatDateTime(file.created_at)}</div>
              <div>
                <ViewFileById fileId={file.id} />
              </div>
              <div className={styles.actions}>
                {(isAdmin || (!deleteBan && isWithinLastHalfHour(file.created_at))) && <ButtonWithConfirmation entryFunc={() => handleDelete(file.id)} />}
              </div>
            </div>
        ))}
      </div>}
    </>
  )
}

export default FilesMiniTable;
